// Template labels are localized: `titleKey`/`tagKeys` resolve against
// messages/*/landing.json (templates.*). The React consumer resolves them via t().
export interface Template {
  id: string;
  titleKey: string;
  tagKeys: string[];
}

export const templates: Template[] = [
  {
    id: "vetrnik",
    titleKey: "vetrnik",
    tagKeys: ["onePage", "industrial"],
  },
  {
    id: "smak",
    titleKey: "smak",
    tagKeys: ["onePage", "fresh"],
  },
  {
    id: "jedlik",
    titleKey: "jedlik",
    tagKeys: ["onePage", "retro"],
  },
  {
    id: "gurman",
    titleKey: "gurman",
    tagKeys: ["onePage", "classic"],
  },
  {
    id: "somelier",
    titleKey: "somelier",
    tagKeys: ["multiPage", "luxury"],
  },
  {
    id: "chutovka",
    titleKey: "chutovka",
    tagKeys: ["onePage", "natural"],
  },
  {
    id: "stava",
    titleKey: "stava",
    tagKeys: ["onePage", "elegant"],
  },
  {
    id: "kulinar",
    titleKey: "kulinar",
    tagKeys: ["onePage", "bold"],
  },
  {
    id: "labuznik",
    titleKey: "labuznik",
    tagKeys: ["multiPage", "modern"],
  },
  {
    id: "mlsoun",
    titleKey: "mlsoun",
    tagKeys: ["onePage", "playful"],
  },
];
